import { useRouter } from 'next/router'

import { POLICY_LANG_CONFIG } from './constants'
import getQueryString from './get-query-string'

export const useGetTermsAndConditionsUrl = () => {
  const { query } = useRouter()

  const tcString =
    getQueryString(query.locale) === 'en'
      ? 'terms-and-conditions'
      : 'termini-e-condizioni'

  const policyCode = POLICY_LANG_CONFIG[getQueryString(query.locale)]

  return `https://www.iubenda.com/${tcString}/${policyCode}`
}
